import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";
import store from "@/state/store";
import routes from "./routes";
import Swal from "sweetalert2";
import AccountService from "../services/account.service";

Vue.use(VueRouter);
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: "page",
});

const vm = new Vue();

var router = new VueRouter({
  routes: routes,
  mode: "history",
});

const handleConfirm = async () => {
  try {
    await AccountService.acceptTerms();

    store.dispatch("setTermsUseConduct", true);

    router.go(0);
  } catch {
    Swal.fire({
      icon: "info",
      title: "",
      text: vm.$ml.get("unableToCompleteThisRequest"),
    });
  }
};

const handleCancel = (next) => {
  store.dispatch("resetUser");
  next("/login");
};

const showTermsUseConductModal = (next) => {
  Swal.fire({
    html: `
      <p>
      ${vm.$ml.get("youMustAgreeToThe")}
        <a
          href="https://bughunt.com.br/terms"
          target="_blank"
          rel="noopener noreferrer"
        >
        ${vm.$ml.get("termsOfUse")}
        </a>

        ${vm.$ml.get("and")}

        <a
          href="https://bughunt.com.br/code-of-conduct"
          target="_blank"
          rel="noopener noreferrer"
        >${vm.$ml.get("codeOfConduct")}
        </a>
      </p>
    `,
    icon: "info",
    showCancelButton: true,
    confirmButtonText: vm.$ml.get("agree"),
    cancelButtonText: vm.$ml.get("cancel"),
  }).then((result) => {
    if (result.isConfirmed) {
      handleConfirm(next);
    }

    if (result.isDismissed) {
      handleCancel(next);
    }
  });
};

// Before each route evaluates...
router.beforeEach(async (routeTo, routeFrom, next) => {
  if (routeTo.params.slug) document.title = routeTo.params.slug;

  const publicPages = [
    "/login",
    "/register",
    "/register_ame",
    "/register_avenue",
    "/register_natura",
    "/api_vibe_check",
    "/company",
    "/company/member",
    "/forgot-password",
    "/reset-password",
    "/validation",
    "/program-list",
    "/:slug",
    "/auth/sso",
    "/auth/sso/",
    "/sso/logout",
  ];

  const authpage = !publicPages.includes(routeTo.path);

  const loggeduser = store.getters["getLoggedIn"];

  const termsUseConduct = store.getters["getTermsUseConduct"];

  if (loggeduser && !termsUseConduct) {
    showTermsUseConductModal(next);
  }

  if (authpage && !loggeduser && !routeTo.meta.slug) {
    await store.dispatch("setRouteTo", routeTo.fullPath);

    return next("/login");
  }

  next();
});

export default router;
